/**
 * Vuikit 0.8.10
 * (c) 2018 Miljan Aleksic
 * @license MIT
**/

/* Substantial part of the code is adapted from UIkit,
  Copyright (c) 2013-2018 YOOtheme GmbH, getuikit.com */

import { fragment } from './dom';
import { find, findAll } from './selector';
import { isString, toNode, toNodes } from './lang';

function $ (selector, context) {
  return !isString(selector)
    ? toNode(selector)
    : isHtml(selector)
      ? toNode(fragment(selector))
      : find(selector, context)
}
function $$ (selector, context) {
  return !isString(selector)
    ? toNodes(selector)
    : isHtml(selector)
      ? toNodes(fragment(selector))
      : findAll(selector, context)
}
function isHtml (str) {
  return str[0] === '<' || str.match(/^\s*</)
}

export { $, $$ };



//////////////////
// WEBPACK FOOTER
// ./node_modules/vuikit/lib/util/core.js
// module id = null
// module chunks = 